export type ProductState =
  | 'Standard Price'
  | 'Promotion'
  | 'Promo Data'
  | 'Promotion and Promo Data'
  | 'Mixed';

export const STATE_COLORS: Record<ProductState, string> = {
  'Standard Price': '#6b7280',
  Promotion: '#f59e0b',
  'Promo Data': '#3b82f6',
  'Promotion and Promo Data': '#8b5cf6',
  Mixed: '#64748b',
};

// Revenue / monetary fields (avg_daily_value, total_value, total_item_value)
// are intentionally not exposed on these types while the SPAR per-unit vs
// extended price ambiguity is unresolved. Comparisons across the dashboard
// are unit-based; see the spar-basket-price-ambiguity canvas + investigation.
export interface StateComparisonRow {
  state: ProductState;
  day_product_combos: number;
  distinct_calendar_days: number;
  distinct_products: number;
  total_units: number;
  avg_daily_units: number;
}

export interface TimelineRow {
  sale_date: string;
  units_sold: number;
  winning_state: ProductState;
  top_state_share_pct?: number | null;
  pct_standard?: number | null;
  pct_promotion?: number | null;
  pct_promo_data?: number | null;
  pct_both?: number | null;
  has_discount: number;
  has_promo_data: number;
  active_rule_titles: string | null;
}

export interface RuleRow {
  id: number;
  title: string;
  rule_type: string;
  promo_start_date: string;
  promo_end_date: string;
  mb_reward: number;
  status: string;
  gtin_count: number;
  gtins_triggered: number;
  total_attributions: number;
  total_gb_allocated: number;
}

export interface ProductSearchRow {
  gtin: string;
  description: string | null;
  avg_units_promo_data: number | null;
  avg_units_no_promo_data: number | null;
  uplift_pct: number | null;
  days_with_promo_data: number;
  days_without_promo_data: number;
}

export interface UpliftRow {
  gtin: string;
  description: string | null;
  avg_units_promo_data: number;
  avg_units_no_promo_data: number;
  uplift_pct: number;
  days_with_promo_data: number;
  days_without_promo_data: number;
}

export const ANALYSIS_START_DATE = '2025-03-24';
export const DAY_WINNER_MIN_UNIT_SHARE = 0.5;

export function analysisEndDate(): string {
  return new Date().toISOString().slice(0, 10);
}
